import { BaseSelectionItem } from "@frend-digital/centra-types/selection";
import { create } from "zustand";

export type RemovedProduct = {
  id: string;
  quantity: number;
  index: number;
  optimisticItem?: BaseSelectionItem;
};

interface RemovedProductsStore {
  item: null | BaseSelectionItem;
  addItem: (removedProduct: BaseSelectionItem) => void;
  clearItem: () => void;
}

export const useRemovedProduct = create<RemovedProductsStore>(set => ({
  item: null,
  addItem: item => set(() => ({ item: item })),
  clearItem: () => set(() => ({ item: null })),
}));
